import { EmptyState, Progress } from '@backstage/core-components';
import {
  createFrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { Container, Flex, Grid, Header } from '@backstage/ui';
import {
  Card,
  CardActionArea,
  CardContent,
  Typography,
} from '@material-ui/core';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import { Link as RouterLink } from 'react-router-dom';
import { useAdminSections } from './useAdminSections';

const AdminSettingsPage = () => {
  const { sections, loading } = useAdminSections();

  const renderContent = () => {
    if (loading) {
      return <Progress />;
    }
    if (sections.length === 0) {
      return (
        <EmptyState
          missing="info"
          title="No admin access"
          description="You don't have access to any admin settings."
        />
      );
    }
    return (
      <Grid.Root columns={{ initial: '1', sm: '2', lg: '3' }} gap="4">
        {sections.map(({ title, to, icon: Icon, description }) => (
          <Card key={to} style={{ width: '100%' }}>
            <CardActionArea
              component={RouterLink}
              to={to}
              style={{ height: '100%' }}
            >
              <CardContent>
                <Flex align="center" gap="2">
                  <Icon color="primary" />
                  <Typography variant="h6">{title}</Typography>
                </Flex>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  style={{ marginTop: 8 }}
                >
                  {description}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </Grid.Root>
    );
  };

  return (
    <>
      <Header title="Admin Settings" description="Portal administration" />
      <Container>{renderContent()}</Container>
    </>
  );
};

const adminSettingsPage = PageBlueprint.make({
  name: 'admin-settings',
  params: {
    path: '/admin-settings',
    title: 'Admin Settings',
    icon: <SupervisorAccountIcon />,
    loader: async () => <AdminSettingsPage />,
  },
});

export const adminModule = createFrontendModule({
  pluginId: 'app',
  extensions: [adminSettingsPage],
});